<template>
  <div>
    <div style="height: 54px" class="sub-nav-box-1">
      <!-- judul halaman -->
      <h2>Cabang</h2>
    </div>
    <!-- main view halaman -->
    <div style="margin-top: 70px; background: none" class="main-view">
      <div class="table-navigation">
        <!-- list filter -->
        <div class="list-filter"></div>
        <!-- end of list filter -->

        <!-- bagian untuk cari tambah dan download -->
        <div class="cari-tambah-download">
          <!-- box pencarian -->
          <div class="cari">
            <svg
              style="margin-right: 8px"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <input
              v-model="filterData.pencarian"
              placeholder="Cari"
              type="text"
              name=""
              id=""
            />
          </div>
          <!-- button tambah -->
          <button @click="openCloseModalTambah(true)" class="add">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.00003 5.14314V10.8574M5.14289 8.00028H10.8572M15.1429 8.00028C15.1429 11.9452 11.9449 15.1431 8.00003 15.1431C4.05514 15.1431 0.857178 11.9452 0.857178 8.00028C0.857178 4.05539 4.05514 0.857422 8.00003 0.857422C11.9449 0.857422 15.1429 4.05539 15.1429 8.00028Z"
                stroke="#FCFCFC"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <!-- open menu mobile -->
          <div class="open-menu-mobile">
            <!-- menu icon -->
            <svg
              @click="openCloseMenuMobile(true)"
              width="14"
              height="4"
              viewBox="0 0 14 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <!-- end of menu icon -->

            <div
              style="display: none"
              ref="box-pilihan-menu"
              class="box-pilihan-aksi"
            >
              <!-- tambah cabang -->
              <p @click="openCloseModalTambah(true)">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00003 5.14265V10.8569M5.14289 7.99979H10.8572M15.1429 7.99979C15.1429 11.9447 11.9449 15.1426 8.00003 15.1426C4.05514 15.1426 0.857178 11.9447 0.857178 7.99979C0.857178 4.0549 4.05514 0.856934 8.00003 0.856934C11.9449 0.856934 15.1429 4.0549 15.1429 7.99979Z"
                    stroke="#FFB700"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Tambah
              </p>
            </div>
          </div>
          <!-- end of open menu mobile -->
        </div>
      </div>
      <!-- end of bagian untuk cari tambah dan download -->
      <div class="box-table">
        <table>
          <!-- judul tabel -->
          <tr>
            <th>ID Cabang</th>
            <th>Nama Cabang</th>
            <th>Alamat</th>
            <th>Manager HR</th>
            <th>Status</th>
            <th></th>
          </tr>
          <!-- start iterasi tabel -->
          <tr :key="index" v-for="(cabang, index) in filteredDataCabang">
            <!-- id cabang -->
            <td>{{ cabang.id }}</td>
            <!-- nama cabang -->
            <td>{{ cabang.nama }}</td>
            <!-- alamat -->
            <td>{{ cabang.alamat }}</td>
            <!-- Nama Manager HR -->
            <td>{{ cabang.manager }}</td>
            <!-- status -->
            <td v-if="cabang.status === 'Aktif'" class="tipe-presensi">
              <span>{{ cabang.status }}</span>
            </td>
            <td v-else class="tipe-absen">
              <span>{{ cabang.status }}</span>
            </td>
            <!-- action -->
            <td style="padding-left: 32px; position: relative">
              <svg
                @click="openCloseAction(true, index)"
                width="14"
                height="4"
                viewBox="0 0 14 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99993 2.7147C7.39442 2.7147 7.71422 2.39491 7.71422 2.00042C7.71422 1.60593 7.39442 1.28613 6.99993 1.28613C6.60544 1.28613 6.28564 1.60593 6.28564 2.00042C6.28564 2.39491 6.60544 2.7147 6.99993 2.7147Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.9999 2.7147C12.3944 2.7147 12.7142 2.39491 12.7142 2.00042C12.7142 1.60593 12.3944 1.28613 11.9999 1.28613C11.6054 1.28613 11.2856 1.60593 11.2856 2.00042C11.2856 2.39491 11.6054 2.7147 11.9999 2.7147Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.99993 2.7147C2.39442 2.7147 2.71422 2.39491 2.71422 2.00042C2.71422 1.60593 2.39442 1.28613 1.99993 1.28613C1.60544 1.28613 1.28564 1.60593 1.28564 2.00042C1.28564 2.39491 1.60544 2.7147 1.99993 2.7147Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div
                style="display: none"
                ref="box-pilihan-aksi"
                class="box-pilihan-aksi"
              >
                <!-- aksi edit -->
                <p @click="openCloseModalEdit(true, index)">
                  <svg
                    width="15"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.06091 15.1451H13.9836M10.1828 0.859375L13.2234 3.71652L4.8617 11.5737H1.82107V8.71652L10.1828 0.859375Z"
                      stroke="#2F80ED"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Edit
                </p>
              </div>
            </td>
          </tr>
          <!-- end of iterasi tabel -->
        </table>
        <p
          v-if="!filteredDataCabang || filteredDataCabang.length === 0"
          class="empty-state-table"
        >
          Belum ada data
        </p>
      </div>
    </div>
    <!-- end of main view halaman -->

    <!-- modal tambah cabang -->
    <ModalInput v-if="modalInputIsOpen">
      <div style="width: 730px" class="content">
        <h2>Tambah Cabang</h2>
        <!-- input form -->
        <div class="list-form-modal">
          <!-- input id cabang -->
          <div ref="id-form-tambah" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 5.69351H12.7142M1.28564 10.3089H12.7142M5.57136 1.07812L4.14279 14.9243M9.85707 1.07812L8.4285 14.9243"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.id" class="input-title">ID Cabang</span>
              <input
                v-model="tambahCabang.id"
                class="input-text"
                required
                placeholder="ID Cabang"
                type="text"
              />
            </div>
          </div>
          <!-- input nama cabang -->
          <div ref="nama-form-tambah" class="box-form email">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.856934 11.5737L7.99979 15.1451L15.1426 11.5737M0.856934 8.00223L7.99979 11.5737L15.1426 8.00223M7.99979 0.859375L0.856934 4.4308L7.99979 8.00223L15.1426 4.4308L7.99979 0.859375Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.nama" class="input-title"
                >Nama Cabang</span
              >
              <input
                v-model="tambahCabang.nama"
                class="input-text"
                required
                placeholder="Nama Cabang"
                type="text"
              />
            </div>
          </div>
          <!-- input alamat -->
          <div ref="alamat-form-tambah" class="box-form email">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 3.43192V1.28906H12.7142V3.43192M4.85707 12.7176H9.14279M6.99993 1.28906V12.7176"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.alamat" class="input-title">Alamat</span>
              <input
                v-model="tambahCabang.alamat"
                class="input-text"
                required
                placeholder="Alamat"
                type="text"
              />
            </div>
          </div>
          <!-- input nama manager hrd -->
          <div ref="managerHrd-form-tambah" class="box-form email">
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5716 13.4275V11.9989C12.5716 11.2411 12.2706 10.5144 11.7348 9.97858C11.199 9.44276 10.4723 9.14174 9.7145 9.14174H4.00021C3.24245 9.14174 2.51572 9.44276 1.9799 9.97858C1.44409 10.5144 1.14307 11.2411 1.14307 11.9989V13.4275M16.8574 13.4275V11.9989C16.8569 11.3658 16.6462 10.7509 16.2583 10.2505C15.8705 9.75021 15.3274 9.39286 14.7145 9.2346M11.8574 0.66317C12.4719 0.1024528 13.0167 1.17796 13.4057 1.67911C13.7947 2.18026 14.0058 2.79662 14.0058 3.43103C14.0058 4.06543 13.7947 4.6818 13.4057 5.18295C13.0167 5.6841 12.4719 6.04153 11.8574 6.19888M9.7145 3.42746C9.7145 5.00541 8.43531 6.2846 6.85735 6.2846C5.2794 6.2846 4.00021 5.00541 4.00021 3.42746C4.00021 1.8495 5.2794 0.570312 6.85735 0.570312C8.43531 0.570312 9.7145 1.8495 9.7145 3.42746Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.managerHrd" class="input-title"
                >Manager Cabang</span
              >
              <input
                v-model="tambahCabang.managerHrd"
                class="input-text"
                required
                placeholder="Manager Cabang"
                type="text"
              />
            </div>
          </div>

          <!-- input email -->
          <div ref="email-form-tambah" class="box-form email">
            <svg
              width="18"
              height="16"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1429 2.71434C15.1429 1.92862 14.5 1.28577 13.7143 1.28577H2.28575C1.50003 1.28577 0.857178 1.92862 0.857178 2.71434M15.1429 2.71434V11.2858C15.1429 12.0715 14.5 12.7143 13.7143 12.7143H2.28575C1.50003 12.7143 0.857178 12.0715 0.857178 11.2858V2.71434M15.1429 2.71434L8.00003 7.71434L0.857178 2.71434"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="input-and-title">
              <span v-if="tambahCabang.emailHrd" class="input-title"
                >Email</span
              >
              <input
                v-model="tambahCabang.emailHrd"
                class="input-text"
                required
                placeholder="Email Manager HRD"
                type="text"
              />
            </div>
          </div>
          <!-- end of input email -->

          <!-- input status -->
          <div class="keterangan">
            <div
              ref="status-form-tambah"
              @click="openClosePilihanStatus(true)"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857178 11.5717L8.00003 15.1431L15.1429 11.5717M0.857178 8.00028L8.00003 11.5717L15.1429 8.00028M8.00003 0.857422L0.857178 4.42885L8.00003 8.00028L15.1429 4.42885L8.00003 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="input-and-title">
                <span
                  v-if="tambahCabang.status"
                  style="display: block"
                  class="input-title"
                  >Status</span
                >

                <p>
                  {{ tambahCabang.status ? tambahCabang.status : "Status" }}
                </p>
              </div>
            </div>
            <!-- box pilihan transaksi -->
            <div
              style="display: none"
              ref="boxPilihanStatus"
              class="box-pilihan"
            >
              <p
                :key="status"
                v-for="status in listStatusCabang"
                @click="openClosePilihanStatus(false, status)"
              >
                {{ status }}
                <svg
                  v-if="status === tambahCabang.status"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan transaksi -->
          </div>
        </div>
        <!-- end of input form -->
        <button
          :disabled="isProcessing"
          @click="tambahkanCabang"
          style="margin-left: 20px; margin-bottom: 20px"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-text">Simpan</span>
        </button>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseModalTambah(false)"
        style="margin-top: -285px"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalInput>
    <!-- end of modal tambah cabang -->

    <!-- modal edit cabang -->
    <ModalInput v-if="modalEditIsOpen">
      <div style="width: 730px" class="content">
        <h2>Edit Cabang</h2>
        <!-- input form -->
        <div class="list-form-modal">
          <!-- input id cabang -->
          <div ref="id-form-edit" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 5.69351H12.7142M1.28564 10.3089H12.7142M5.57136 1.07812L4.14279 14.9243M9.85707 1.07812L8.4285 14.9243"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.id" class="input-title">ID Cabang</span>
              <input
                v-model="tambahCabang.id"
                class="input-text"
                required
                placeholder="ID Cabang"
                type="text"
              />
            </div>
          </div>
          <!-- input nama cabang -->
          <div ref="nama-form-edit" class="box-form email">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.856934 11.5737L7.99979 15.1451L15.1426 11.5737M0.856934 8.00223L7.99979 11.5737L15.1426 8.00223M7.99979 0.859375L0.856934 4.4308L7.99979 8.00223L15.1426 4.4308L7.99979 0.859375Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.nama" class="input-title"
                >Nama Cabang</span
              >
              <input
                v-model="tambahCabang.nama"
                class="input-text"
                required
                placeholder="Nama Cabang"
                type="text"
              />
            </div>
          </div>
          <!-- input alamat -->
          <div ref="alamat-form-edit" class="box-form email">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 3.43192V1.28906H12.7142V3.43192M4.85707 12.7176H9.14279M6.99993 1.28906V12.7176"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.alamat" class="input-title">Alamat</span>
              <input
                v-model="tambahCabang.alamat"
                class="input-text"
                required
                placeholder="Alamat"
                type="text"
              />
            </div>
          </div>
          <!-- input nama manager hrd -->
          <div ref="managerHrd-form-edit" class="box-form email">
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5716 13.4275V11.9989C12.5716 11.2411 12.2706 10.5144 11.7348 9.97858C11.199 9.44276 10.4723 9.14174 9.7145 9.14174H4.00021C3.24245 9.14174 2.51572 9.44276 1.9799 9.97858C1.44409 10.5144 1.14307 11.2411 1.14307 11.9989V13.4275M16.8574 13.4275V11.9989C16.8569 11.3658 16.6462 10.7509 16.2583 10.2505C15.8705 9.75021 15.3274 9.39286 14.7145 9.2346M11.8574 0.66317C12.4719 0.1024528 13.0167 1.17796 13.4057 1.67911C13.7947 2.18026 14.0058 2.79662 14.0058 3.43103C14.0058 4.06543 13.7947 4.6818 13.4057 5.18295C13.0167 5.6841 12.4719 6.04153 11.8574 6.19888M9.7145 3.42746C9.7145 5.00541 8.43531 6.2846 6.85735 6.2846C5.2794 6.2846 4.00021 5.00541 4.00021 3.42746C4.00021 1.8495 5.2794 0.570312 6.85735 0.570312C8.43531 0.570312 9.7145 1.8495 9.7145 3.42746Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahCabang.managerHrd" class="input-title"
                >Manager Cabang</span
              >
              <input
                v-model="tambahCabang.managerHrd"
                class="input-text"
                required
                placeholder="Manager Cabang"
                type="text"
              />
            </div>
          </div>
          <!-- input email -->
          <div ref="email-form-edit" class="box-form email">
            <svg
              width="18"
              height="16"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1429 2.71434C15.1429 1.92862 14.5 1.28577 13.7143 1.28577H2.28575C1.50003 1.28577 0.857178 1.92862 0.857178 2.71434M15.1429 2.71434V11.2858C15.1429 12.0715 14.5 12.7143 13.7143 12.7143H2.28575C1.50003 12.7143 0.857178 12.0715 0.857178 11.2858V2.71434M15.1429 2.71434L8.00003 7.71434L0.857178 2.71434"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="input-and-title">
              <span v-if="tambahCabang.emailHrd" class="input-title"
                >Email</span
              >
              <input
                v-model="tambahCabang.emailHrd"
                class="input-text"
                required
                placeholder="Email Manager HRD"
                type="text"
              />
            </div>
          </div>
          <!-- end of input email -->
          <!-- input status -->
          <div class="keterangan">
            <div
              ref="status-form-edit"
              @click="openClosePilihanStatus(true)"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857178 11.5717L8.00003 15.1431L15.1429 11.5717M0.857178 8.00028L8.00003 11.5717L15.1429 8.00028M8.00003 0.857422L0.857178 4.42885L8.00003 8.00028L15.1429 4.42885L8.00003 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="input-and-title">
                <span
                  v-if="tambahCabang.status"
                  style="display: block"
                  class="input-title"
                  >Status</span
                >

                <p>
                  {{ tambahCabang.status ? tambahCabang.status : "Status" }}
                </p>
              </div>
            </div>
            <!-- box pilihan transaksi -->
            <div
              style="display: none"
              ref="boxPilihanStatus"
              class="box-pilihan"
            >
              <p
                :key="status"
                v-for="status in listStatusCabang"
                @click="openClosePilihanStatus(false, status)"
              >
                {{ status }}
                <svg
                  v-if="status === tambahCabang.status"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan transaksi -->
          </div>
        </div>
        <!-- end of input form -->
        <button
          :disabled="isProcessing"
          @click="editCabang"
          style="margin-left: 20px; margin-bottom: 20px"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-text">Simpan</span>
        </button>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseModalEdit(false)"
        style="margin-top: -285px"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalInput>
    <!-- end of modal edit cabang -->

    <!-- modal alert non aktif -->
    <ModalNonaktif v-if="modalNonaktifIsOpen">
      <div class="content">
        <!-- icon -->
        <svg
          style="margin-bottom: 8px"
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#EB5757" />
          <path
            d="M42.7679 22.8984C43.5377 21.5651 45.4622 21.5651 46.2321 22.8984L68.3157 61.1484C69.0855 62.4818 68.1232 64.1484 66.5836 64.1484H22.4164C20.8768 64.1484 19.9145 62.4818 20.6843 61.1484L42.7679 22.8984Z"
            fill="#FCFCFC"
          />
          <path
            d="M46.1223 37.6016L45.5913 52.3516H42.0808L41.5498 37.6016H46.1223ZM46.0928 54.9476V59.2841H41.6088V54.9476H46.0928Z"
            fill="#EB5757"
          />
        </svg>
        <!-- end of icon -->
        <div class="text-modal">
          <!-- note -->
          <h2 class="primary-text">Yakin untuk menonaktifkan cabang?</h2>
          <p style="text-align: center">
            Cabang yang dinonaktifkan tidak bisa dikembalikan <br />
            selama 3x24 jam ke depan
          </p>

          <div class="list-button">
            <button
              :disabled="isProcessing"
              @click="nonAktifkanCabang"
              class="delete"
            >
              <div ref="spinner" style="display: none" class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
              <span ref="button-text">Nonaktifkan</span>
            </button>
            <button @click="openCloseModalNonaktif(false)" class="cancel">
              Batal
            </button>
          </div>
        </div>
      </div>

      <!-- close button -->
      <svg
        @click="openCloseModalNonaktif(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalNonaktif>
    <!-- end of modal alret non aktif -->

    <!-- modal ga bisa non aktif -->
    <ModalTidakBisaNonaktif v-if="modalGabisaNonaktifIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#EB5757" />
          <path
            d="M42.7679 22.8984C43.5377 21.5651 45.4622 21.5651 46.2321 22.8984L68.3157 61.1484C69.0855 62.4818 68.1232 64.1484 66.5836 64.1484H22.4164C20.8768 64.1484 19.9145 62.4818 20.6843 61.1484L42.7679 22.8984Z"
            fill="#FCFCFC"
          />
          <path
            d="M46.1223 37.6016L45.5913 52.3516H42.0808L41.5498 37.6016H46.1223ZM46.0928 54.9476V59.2841H41.6088V54.9476H46.0928Z"
            fill="#EB5757"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2 class="primary-text">Status cabang belum dapat diubah</h2>
        <p style="text-align: center">
          Mohon maaf, status cabang tidak dapat diubah <br />
          hingga 3x24 jam setelah penonaktifan
        </p>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalGabisaNonaktif(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalTidakBisaNonaktif>
    <!-- end modal ga bisa non aktif -->

    <!-- modal berhasil -->
    <ModalBerhasil v-if="modalBerhasilIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65.4526 42.0845V44.0121C65.45 48.5303 63.987 52.9267 61.2817 56.5454C58.5764 60.1642 54.7738 62.8116 50.441 64.0927C46.1082 65.3737 41.4773 65.2199 37.2391 63.6541C33.0009 62.0883 29.3824 59.1944 26.9232 55.4041C24.464 51.6137 23.296 47.13 23.5933 42.6215C23.8906 38.1131 25.6372 33.8215 28.5728 30.3869C31.5084 26.9523 35.4756 24.5586 39.8827 23.5629C44.2899 22.5672 48.9008 23.0227 53.0279 24.8616M65.4526 27.2502L44.5002 48.2236L38.2145 41.9378"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sukses Tambah Data</h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalBerhasil(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasil>
    <!-- end of modal berhasil -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import ModalInput from "@/components/modal/ModalInput";
import ModalBerhasil from "@/components/modal/ModalAlert";
import ModalNonaktif from "@/components/modal/Modal";
import ModalTidakBisaNonaktif from "@/components/modal/ModalAlert";
import * as soluhafire from "@/soluhafire";

export default {
  components: {
    ModalNonaktif,
    ModalInput,
    ModalBerhasil,
    ModalTidakBisaNonaktif,
  },

  data() {
    return {
      isProcessing: false,
      chosenIndex: null,
      editIndex: null,
      // apakah bisa ganti ke non aktif?
      canChangeToNonaktif: true,
      // status modal
      modalNonaktifIsOpen: false,
      modalInputIsOpen: false,
      modalEditIsOpen: false,
      modalBerhasilIsOpen: false,
      modalGabisaNonaktifIsOpen: false,
      // filter
      filterData: {
        pencarian: "",
      },
      // tambah cabang
      tambahCabang: {
        id: "",
        nama: "",
        emailHrd: "",
        alamat: "",
        managerHrd: "",
        status: "",
      },
    };
  },

  methods: {
    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseAction(open, index) {
      let box = this.$refs["box-pilihan-aksi"][index];
      // tutup box action yang lain
      this.$refs["box-pilihan-aksi"].forEach((refs) => {
        refs.style.display = "none";
      });
      if (open) {
        box.style.display = "block";
        this.chosenIndex = index;
      } else {
        box.style.display = "none";
      }
    },

    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    openCloseModalTambah(isOpen) {
      if (isOpen) {
        this.openCloseMenuMobile(false);
        this.modalInputIsOpen = true;
      } else {
        this.modalInputIsOpen = false;
      }
    },

    openCloseModalEdit(isOpen, index) {
      if (isOpen) {
        this.openCloseMenuMobile(false);
        this.openCloseAction(false, index);
        let data = this.filteredDataCabang[index];
        // assign variabel edit
        this.tambahCabang.id = data.id;
        this.tambahCabang.nama = data.nama;
        this.tambahCabang.alamat = data.alamat;
        this.tambahCabang.managerHrd = data.manager;
        this.tambahCabang.emailHrd = data.email;
        this.tambahCabang.status = data.status;
        // cek apakah bisa ganti ke non aktif
        if (data.riwayatNonaktif && data.status === "Aktif") {
          let tanggalNonaktif = new Date(data.riwayatNonaktif.seconds * 1000);
          // tanggal non aktif tiga hari kedepan
          tanggalNonaktif.setDate(tanggalNonaktif.getDate() + 3);
          let tanggalSekarang = new Date();
          // ketika lebih dari tiga hari (bisa ganti ke non aktif)
          if (tanggalSekarang.getTime() >= tanggalNonaktif.getTime()) {
            this.canChangeToNonaktif = true;
          } else this.canChangeToNonaktif = false;
        } else this.canChangeToNonaktif = true;
        this.modalEditIsOpen = true;
      } else {
        this.modalEditIsOpen = false;
        // reset state
        this.tambahCabang.id = "";
        this.tambahCabang.nama = "";
        this.tambahCabang.alamat = "";
        this.tambahCabang.managerHrd = "";
        this.tambahCabang.emailHrd = "";
        this.tambahCabang.status = "";
      }
    },

    openCloseModalNonaktif(isOpen) {
      if (isOpen) {
        this.modalNonaktifIsOpen = true;
      } else {
        this.modalNonaktifIsOpen = false;
      }
    },

    openCloseModalGabisaNonaktif(isOpen) {
      if (isOpen) {
        this.modalGabisaNonaktifIsOpen = true;
      } else {
        this.modalGabisaNonaktifIsOpen = false;
      }
    },

    openClosePilihanStatus(isOpen, value) {
      let box = this.$refs.boxPilihanStatus;
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.tambahCabang.status = value;
      }
    },

    // validate email
    validateEmail(email) {
      let re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

    checkFormTambah() {
      let valid = true;
      let data = this.tambahCabang;

      if (!data.id) {
        this.$refs["id-form-tambah"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.nama) {
        this.$refs["nama-form-tambah"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.emailHrd || !this.validateEmail(data.emailHrd)) {
        this.$refs["email-form-tambah"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.alamat) {
        this.$refs["alamat-form-tambah"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.managerHrd) {
        this.$refs["managerHrd-form-tambah"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.status) {
        this.$refs["status-form-tambah"].classList.add("failed-box-form");
        valid = false;
      }
      return valid;
    },

    checkFormEdit() {
      let valid = true;
      let data = this.tambahCabang;

      if (!data.id) {
        this.$refs["id-form-edit"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.nama) {
        this.$refs["nama-form-edit"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.alamat) {
        this.$refs["alamat-form-edit"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.managerHrd) {
        this.$refs["managerHrd-form-edit"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.emailHrd || !this.validateEmail(data.emailHrd)) {
        this.$refs["email-form-edit"].classList.add("failed-box-form");
        valid = false;
      }

      if (!data.status) {
        this.$refs["status-form-edit"].classList.add("failed-box-form");
        valid = false;
      }
      return valid;
    },

    async tambahkanCabang() {
      let check = this.checkFormTambah();
      this.loader(true);
      if (check) {
        await soluhafire.tambahCabang(
          this.tambahCabang.id,
          this.tambahCabang.nama,
          this.tambahCabang.alamat,
          this.tambahCabang.managerHrd,
          this.tambahCabang.emailHrd,
          this.tambahCabang.status
        );
        this.loader(false);
        this.openCloseModalTambah(false);
        this.openCloseModalBerhasil(true);
        // reset state
        this.tambahCabang.id = "";
        this.tambahCabang.nama = "";
        this.tambahCabang.alamat = "";
        this.tambahCabang.managerHrd = "";
        this.tambahCabang.emailHrd = "";
        this.tambahCabang.status = "";
      } else {
        this.loader(false);
        return;
      }
    },

    async nonAktifkanCabang() {
      this.loader(true);
      if (!this.canChangeToNonaktif) {
        this.openCloseModalGabisaNonaktif(true);
        this.tambahCabang.status = "Aktif";
      }
      // kirim data ke db
      await soluhafire.ubahCabang(
        this.tambahCabang.id,
        this.tambahCabang.nama,
        this.tambahCabang.alamat,
        this.tambahCabang.managerHrd,
        this.tambahCabang.emailHrd,
        this.tambahCabang.status
      );
      this.loader(false);
      this.openCloseModalNonaktif(false);
      this.openCloseModalEdit(false);
    },

    async editCabang() {
      let check = this.checkFormEdit();
      this.loader(true);
      if (check) {
        if (this.tambahCabang.status === "Non Aktif") {
          this.loader(false);
          this.openCloseModalNonaktif(true);
        } else {
          //kirim data ke db
          await soluhafire.ubahCabang(
            this.tambahCabang.id,
            this.tambahCabang.nama,
            this.tambahCabang.alamat,
            this.tambahCabang.managerHrd,
            this.tambahCabang.emailHrd,
            this.tambahCabang.status
          );
          this.loader(false);
          this.openCloseModalEdit(false);
          this.openCloseModalBerhasil(true);
        }
      }
    },

    loader(isLoading) {
      let textButton = this.$refs["button-text"];
      let spinner = this.$refs["spinner"];

      if (isLoading) {
        textButton.style.display = "none";
        spinner.style.display = "block";
        this.isProcessing = true;
      } else {
        textButton.style.display = "block";
        spinner.style.display = "none";
        this.isProcessing = false;
      }
    },
  },

  computed: {
    ...mapState(["listPenempatan", "listStatusCabang", "dataCabang"]),
    filteredDataCabang() {
      let dataCabang = this.dataCabang;
      let filterPencarian = this.filterData.pencarian.toLowerCase();
      if (dataCabang) {
        return dataCabang.filter(function (cabang) {
          let filtered;
          if (filterPencarian && filterPencarian.length > 0) {
            filtered = cabang.nama.toLowerCase().includes(filterPencarian);
          } else filtered = dataCabang;
          return filtered;
        });
      } else return [];
    },
  },
};
</script>

<style scoped></style>
